import React, { useMemo } from 'react'
import {
  makeStyles, createStyles, Theme,
  Grid, FormControlLabel, Checkbox, FormControl, TextField, FormHelperText, InputLabel, Select, Chip, MenuItem, ListItemText, OutlinedInput, FormLabel, RadioGroup, Radio, FormGroup, Button
} from '@material-ui/core';
import * as wjInput from '@grapecity/wijmo.react.input';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { typeCisUserList, typeContractList } from '../../../../api/helpline/keiyaku'
import { Autocomplete } from '@material-ui/lab';
import { typeForm } from '../../../../pages/ContractRegist';
import { typeCategory, typeMemberList } from '../../../../api/helpline/master';
import { green } from '@material-ui/core/colors';
import NumberFormatInput from '../../NumberFormatInput';



const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      width: '90%',
      margin: theme.spacing(2),
      padding: theme.spacing(1),
    },
    mWidth: {
      minWidth: "50%",
      maxWidth: "350px",
    },
    suport: {
      marginTop: theme.spacing(1),
      width: "80%",
    },
    departmentWidth: {
      marginTop: theme.spacing(1),
      width: "90%",
      maxWidth: "700px"
    },
    keiyakuWidth: {
      marginTop: theme.spacing(1),
      maxWidth: "700px",
      minWidth: "400px"
    },
    lWidth: {
      marginTop: theme.spacing(1),
      maxWidth: "700px",
      minWidth: "200px"
    },
    fullWidth: {
      width: '80%'
    },
    button: {
      margin: theme.spacing(1),
    },
    wrapper: {
      position: 'relative',
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    chip: {
      margin: "2px 2px 2px"
    },
    chips: {
      display: "flex",
      flexWrap: "wrap"
    },
    legendlabel: {
      fontSize: '0.8rem'
    }
  }),
);


const ITEM_HEIGHT = 90;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      minWidth: 200,
      maxWidth: 200
    }
  }
};

interface Prop {
  reqbasicItem: {
    custmNo: boolean; custmDepNo: boolean; keiyakuNo: boolean; orderNo: boolean; keiyakuClsCd: boolean; keiyakuStartTs: boolean; renewalMonth: boolean; keiyakuPersonCd: boolean; keiyakuDeposit: boolean; totalPrice: boolean; machineSettingZipCd: boolean; machineSettingAddress: boolean;
  },
  handleChangeForm: (event: React.ChangeEvent<{ value: unknown; name?: string | undefined; }>) => void,
  form: typeForm | null | undefined,
  _onInitialized: (sender: any) => void,
  contractList: typeContractList[] | undefined,
  handleChangeKeiyakuCd: (keiyakuObj: typeContractList) => void,
  chipDelete: (i: number, name: string) => void,
  monthList: number[],
  memberList: typeMemberList[] | undefined,
  handleChangeUserCd: (memberObj: typeMemberList) => void,
  payment: typeCategory[],
  cisUserList: typeCisUserList[],
  handleChangeSalesPersonCd: (salesPersonCdObj: typeCisUserList | null) => void,
  handleChangeChecked: (event: React.ChangeEvent<HTMLInputElement>) => void,
  selectmember: typeMemberList | undefined,
  checkbasicItem: { keiyakuNo: boolean; orderNo: boolean; keiyakuDeposit: boolean; totalPrice: boolean; incidentDeposit: boolean; visitCount: boolean; incidentCount: boolean; machineSettingZipCd: boolean; incidentAddCount: boolean; incidentUsedCount: boolean; }
  displayIncident: boolean,
  mailservice: boolean[] | null,
  renewalMonthSelect: { value: string, name: string }[],
  handleChangeRenewalMonth: (event: React.ChangeEvent<HTMLInputElement>) => void,
  renewalSelect: string,
  _onValueChanged: (sender: { value: Date; }) => void,
  kaiyakuTs: Date | null,
  incidentUsedCountReset: () => void
}

const BasicEditForm: React.FC<Prop> = (props) => {
  const classes = useStyles()
  const { reqbasicItem, handleChangeForm, form, _onInitialized, contractList, handleChangeKeiyakuCd, chipDelete, monthList, memberList, handleChangeUserCd, payment, cisUserList, handleChangeSalesPersonCd, handleChangeChecked, selectmember, checkbasicItem, displayIncident, mailservice, renewalMonthSelect, handleChangeRenewalMonth, renewalSelect, _onValueChanged, kaiyakuTs, incidentUsedCountReset } = props

  const keiyaku00 = useMemo(() => {
    const pat00 = /00$/g;
    if (form?.keiyakuNo) {
      return form?.keiyakuNo.match(pat00)
    } else {
      return false
    }
  }, [form?.keiyakuNo])

  return (
    <React.Fragment>
      {form &&
        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
          <Grid item xs={12}>
            <FormControl className={classes.departmentWidth} variant="outlined" margin="dense">
              <TextField id="custmName" name="custmName" label="顧客名 / 組織名" value={form.custmName} size="small" variant="outlined" required disabled />
            </FormControl>
          </Grid>
          {form.custmNo && form.custmDepNo &&
            <React.Fragment>
              <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={1}>
                <Grid item>
                  <FormControl className={classes.mWidth} margin="dense" variant="outlined" error={reqbasicItem.keiyakuNo || checkbasicItem.keiyakuNo}>
                    <TextField id="keiyakuNo" name="keiyakuNo" label="契約書番号" value={form.keiyakuNo}
                      size="small" variant="outlined" required disabled error={reqbasicItem.keiyakuNo || checkbasicItem.keiyakuNo} />
                    {reqbasicItem.keiyakuNo ? <FormHelperText>必須項目です</FormHelperText> : checkbasicItem.keiyakuNo ? <FormHelperText>不正な値です</FormHelperText> : (!checkbasicItem.keiyakuNo && !checkbasicItem.orderNo && !reqbasicItem.keiyakuStartTs && !reqbasicItem.keiyakuClsCd) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item>
                  <FormControl className={classes.mWidth} margin="dense" variant="outlined" error={reqbasicItem.orderNo || checkbasicItem.orderNo}>
                    <TextField id="orderNo" name="orderNo" label="受注番号" value={form.orderNo}
                      size="small" onChange={handleChangeForm} variant="outlined" required error={reqbasicItem.orderNo || checkbasicItem.orderNo} />
                    {reqbasicItem.orderNo ? <FormHelperText>必須項目です</FormHelperText> : checkbasicItem.orderNo ? <FormHelperText>不正な値です</FormHelperText> : (!checkbasicItem.keiyakuNo && !checkbasicItem.orderNo && !reqbasicItem.keiyakuStartTs && !reqbasicItem.keiyakuClsCd) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item>
                  <InputLabel htmlFor='keiyakuStartTs' shrink error={reqbasicItem.keiyakuStartTs}>契約開始日*</InputLabel>
                  <FormControl className={classes.mWidth} id='keiyakuStartTs' margin="dense" style={{ marginTop: '4px' }} variant="outlined" error={reqbasicItem.keiyakuStartTs} disabled>
                    <wjInput.InputDate
                      initialized={_onInitialized}
                      isRequired={true}
                      value={form.keiyakuStartTs}
                      name="keiyakuStartTs"
                      isReadOnly
                    />
                    {reqbasicItem.keiyakuStartTs ? <FormHelperText>必須項目です</FormHelperText> : (!checkbasicItem.keiyakuNo && !checkbasicItem.orderNo && !reqbasicItem.keiyakuStartTs && !reqbasicItem.keiyakuClsCd) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item>
                  {contractList && contractList[0] && (
                    <FormControl className={classes.keiyakuWidth} variant="outlined" margin="dense" error={reqbasicItem.keiyakuClsCd}>
                      <Autocomplete
                        id="keiyakuClsCd"
                        options={contractList!}
                        disableClearable={true}
                        getOptionLabel={(option) => option.keiyakuClsName}
                        defaultValue={contractList!.filter(value => value.keiyakuClsCd === form.keiyakuClsCd)[0]}
                        onChange={(event, value, reason) => handleChangeKeiyakuCd(value)}
                        renderInput={(params) => (
                          <TextField {...params} label="契約項目" variant="outlined" size="small" error={reqbasicItem.keiyakuClsCd} required />
                        )}
                        renderOption={(option, { inputValue }) => {
                          const matches = match((option.keiyakuClsName), inputValue);
                          const parts = parse((option.keiyakuClsName), matches);
                          return (
                            <div>
                              {parts.map((part, index) => (
                                <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                  {part.text}
                                </span>
                              ))}
                            </div>
                          );
                        }}
                      />
                      {reqbasicItem.keiyakuClsCd ? <FormHelperText>必須項目です</FormHelperText> : (!checkbasicItem.keiyakuNo && !checkbasicItem.orderNo && !reqbasicItem.keiyakuStartTs && !reqbasicItem.keiyakuClsCd) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText>}
                    </FormControl>
                  )}
                </Grid>
              </Grid>

              <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={1}>
                <Grid item>
                  <FormControl component="fieldset" variant="outlined" margin="dense">
                    <FormLabel component="legend" className={classes.legendlabel}>更新選択</FormLabel>
                    <RadioGroup row id="renewalClsCd" name="renewalClsCd" onChange={handleChangeRenewalMonth} value={renewalSelect}>
                      {renewalMonthSelect && (
                        renewalMonthSelect.map(value => (
                          <FormControlLabel value={value.value} key={value.value} control={<Radio color="primary" size="small" />} label={value.name} />
                        ))
                      )}
                    </RadioGroup>
                    {renewalSelect === 'cancel' ? !form.kaiyakuTs && <FormHelperText>　</FormHelperText> : !(form.renewalMonth.length === 0) && <FormHelperText>　</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item>
                  {renewalSelect === 'cancel' ?
                    (<React.Fragment>
                      <InputLabel htmlFor='kaiyakuTs' shrink error={reqbasicItem.keiyakuStartTs}>解約日*</InputLabel>
                      <FormControl className={classes.mWidth} id='kaiyakuTs' margin="dense" style={{ marginTop: '4px' }} variant="outlined" error={form.kaiyakuTs ? false : true}>
                        <wjInput.InputDate
                          initialized={_onInitialized}
                          valueChanged={_onValueChanged}
                          isRequired={false}
                          value={kaiyakuTs}
                          name="kaiyakuTs"
                        />
                        {!form.kaiyakuTs && <FormHelperText>必須項目です</FormHelperText>}
                      </FormControl>
                    </React.Fragment>)
                    : (<FormControl variant="outlined" className={classes.lWidth} margin="dense" error={reqbasicItem.renewalMonth} required>
                      <InputLabel id="renewalMonth" variant="outlined">契約更新月</InputLabel>
                      <Select labelId="renewalMonth" id="renewalMonth" label="契約更新月" name="renewalMonth" multiple error={reqbasicItem.renewalMonth}
                        value={form.renewalMonth} onChange={handleChangeForm} MenuProps={MenuProps}
                        renderValue={(selected) => (
                          <div className={classes.chips}>
                            {(form.renewalMonth as number[]).map((value) => (
                              <Chip
                                className={classes.chip}
                                color="primary"
                                variant="outlined"
                                size="small"
                                key={value}
                                label={`${value}月`}
                                onMouseDown={(event) => {
                                  event.stopPropagation();
                                }}
                                onDelete={(event) => chipDelete(value, 'renewalMonth')} />
                            ))}
                          </div>
                        )}
                      >
                        {monthList.map((value) => (
                          <MenuItem key={value} value={value}>
                            <Checkbox color="primary" checked={form.renewalMonth.indexOf(value) > -1} />
                            <ListItemText primary={`${value}月`} />
                          </MenuItem>
                        ))}
                      </Select>
                      {form.renewalMonth.length === 0 && <FormHelperText>必須項目です</FormHelperText>}
                    </FormControl>)
                  }
                </Grid>
              </Grid>

              <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={1}>
                <Grid item>
                  {memberList && memberList[0] &&
                    <FormControl className={classes.lWidth} variant="outlined" margin="dense" error={reqbasicItem.keiyakuPersonCd}>
                      <Autocomplete
                        id="keiyakuPersonCd"
                        disableClearable={true}
                        options={memberList!}
                        defaultValue={memberList!.filter(value => value.userCd === form.keiyakuPersonCd)[0]}
                        getOptionLabel={(option) => option.userName}
                        onChange={(event, value, reason) => handleChangeUserCd(value)}
                        renderInput={(params) => (
                          <TextField {...params} label="契約担当者" variant="outlined" size="small" error={reqbasicItem.keiyakuPersonCd} required />
                        )}
                        renderOption={(option, { inputValue }) => {
                          const matches = match(((option.url ? option.url : '') + ' ' + option.userName), inputValue);
                          const parts = parse(((option.url ? option.url : '') + ' ' + option.userName), matches);
                          return (
                            <div>
                              {parts.map((part, index) => (
                                <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                  {part.text}
                                </span>
                              ))}
                            </div>
                          );
                        }}
                      />
                      {reqbasicItem.keiyakuPersonCd && <FormHelperText>必須項目です</FormHelperText>}
                    </FormControl>
                  }
                </Grid>
                <Grid item>
                  <FormControl className={classes.mWidth} margin="dense" variant="outlined">
                    <TextField id="deptName" name="deptName" label="担当部署" InputLabelProps={{ shrink: true }} value={selectmember?.departmentName} size="small" onChange={handleChangeForm} variant="outlined" disabled />
                    {reqbasicItem.keiyakuPersonCd && <FormHelperText>　</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item>
                  <FormControl className={classes.mWidth} margin="dense" variant="outlined">
                    <TextField id="telephone" name="telephone" label="電話番号" InputLabelProps={{ shrink: true }} value={selectmember?.telephoneNumber} size="small" onChange={handleChangeForm} variant="outlined" disabled />
                    {reqbasicItem.keiyakuPersonCd && <FormHelperText>　</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item>
                  <FormControl className={classes.mWidth} margin="dense" variant="outlined">
                    <TextField id="E-Mail" name="E-Mail" label="E-Mail" InputLabelProps={{ shrink: true }} value={selectmember?.emailAddress1} size="small" onChange={handleChangeForm} variant="outlined" disabled />
                    {reqbasicItem.keiyakuPersonCd && <FormHelperText>　</FormHelperText>}
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={1}>
                <Grid item>
                  <FormControl className={classes.mWidth} margin="dense" variant="outlined" error={reqbasicItem.keiyakuDeposit || checkbasicItem.keiyakuDeposit} required>
                    <InputLabel htmlFor="BasickeiyakuDeposit">契約金額</InputLabel>
                    <OutlinedInput id="BasickeiyakuDeposit" name="keiyakuDeposit" value={form.keiyakuDeposit}
                      margin="dense" onChange={handleChangeForm} required error={reqbasicItem.keiyakuDeposit || checkbasicItem.keiyakuDeposit} inputComponent={NumberFormatInput as any} labelWidth={70} />
                    {reqbasicItem.keiyakuDeposit ? <FormHelperText>必須項目です</FormHelperText> : checkbasicItem.keiyakuDeposit && <FormHelperText>不正な値です</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item>
                  <FormControl component="fieldset" variant="outlined" margin="dense">
                    <FormLabel component="legend" className={classes.legendlabel}>支払い方法</FormLabel>
                    <RadioGroup row id="payClsCd" name="payClsCd" onChange={handleChangeForm} value={form.payClsCd}>
                      {payment && (
                        payment.map(value => (
                          <FormControlLabel value={value.categoryCd} key={value.categoryCd} control={<Radio color="primary" size="small" />} label={value.categoryName} />
                        ))
                      )}
                    </RadioGroup>
                    {(reqbasicItem.keiyakuDeposit || checkbasicItem.keiyakuDeposit) && <FormHelperText>　</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item>
                  {cisUserList && cisUserList[0] &&
                    <FormControl className={classes.keiyakuWidth} variant="outlined" margin="dense">
                      <Autocomplete
                        id="salesPersonCd"
                        options={cisUserList!}
                        value={cisUserList.filter(value => value.userCd === form.salesPersonCd)[0]}
                        getOptionLabel={(option) => `${option.userCd} ${option.userName}`}
                        onChange={(event, value, reason) => handleChangeSalesPersonCd(value)}
                        renderInput={(params) => (
                          <TextField {...params} label="担当営業者" variant="outlined" size="small" />
                        )}
                        renderOption={(option, { inputValue }) => {
                          const matches = match(`${option.userCd} ${option.userName}`, inputValue);
                          const parts = parse(`${option.userCd} ${option.userName}`, matches);
                          return (
                            <div>
                              {parts.map((part, index) => (
                                <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                  {part.text}
                                </span>
                              ))}
                            </div>
                          );
                        }}
                      />
                      {(reqbasicItem.keiyakuDeposit || checkbasicItem.keiyakuDeposit) && <FormHelperText>　</FormHelperText>}
                    </FormControl>
                  }
                </Grid>
              </Grid>

              <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={1}>
                {displayIncident ?
                  (
                    <React.Fragment>
                      <Grid item>
                        <FormControl className={classes.mWidth} margin="dense" variant="outlined" error={checkbasicItem.incidentDeposit}>
                          <InputLabel htmlFor="incidentDeposit">ｵﾝｻｲﾄｲﾝｼﾃﾞﾝﾄｻｰﾋﾞｽ金額</InputLabel>
                          <OutlinedInput id="incidentDeposit" name="incidentDeposit" value={form.incidentDeposit}
                            margin="dense" onChange={handleChangeForm} inputComponent={NumberFormatInput as any} labelWidth={170} error={checkbasicItem.incidentDeposit} />
                          {checkbasicItem.incidentDeposit ? <FormHelperText>不正な値です</FormHelperText> : (!reqbasicItem.totalPrice && !checkbasicItem.totalPrice && !checkbasicItem.incidentDeposit && !checkbasicItem.incidentCount && !checkbasicItem.incidentAddCount) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText>}
                        </FormControl>
                      </Grid>
                      <Grid item>
                        <FormControl className={classes.mWidth} margin="dense" variant="outlined" error={checkbasicItem.incidentCount}>
                          <TextField id="incidentCount" name="incidentCount" label="有効インシデント数" value={form.incidentCount}
                            size="small" onChange={handleChangeForm} variant="outlined" disabled={!keiyaku00} error={checkbasicItem.incidentCount} />
                          {checkbasicItem.incidentCount ? <FormHelperText>不正な値です</FormHelperText> : (!reqbasicItem.totalPrice && !checkbasicItem.totalPrice && !checkbasicItem.incidentDeposit && !checkbasicItem.incidentCount && !checkbasicItem.incidentAddCount && !checkbasicItem.visitCount) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText>}
                        </FormControl>
                      </Grid>
                      <Grid item>
                        <FormControl className={classes.mWidth} margin="dense" variant="outlined" error={checkbasicItem.incidentAddCount}>
                          <TextField id="incidentAddCount" name="incidentAddCount" label="追加インシデント数" value={form.incidentAddCount}
                            size="small" onChange={handleChangeForm} variant="outlined" disabled={!keiyaku00} error={checkbasicItem.incidentAddCount} />
                          {checkbasicItem.incidentAddCount ? <FormHelperText>不正な値です</FormHelperText> : (!reqbasicItem.totalPrice && !checkbasicItem.totalPrice && !checkbasicItem.incidentDeposit && !checkbasicItem.incidentCount && !checkbasicItem.incidentAddCount && !checkbasicItem.visitCount) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText>}
                        </FormControl>
                      </Grid>
                      <Grid item>
                        <Grid container direction="row" justify="flex-start" alignItems="center">
                          <Grid item>
                            <FormControl className={classes.mWidth} margin="dense" variant="outlined" error={checkbasicItem.incidentUsedCount}>
                              <TextField id="incidentUsedCount" name="incidentUsedCount" label="使用済インシデント数" value={form.incidentUsedCount} size="small" variant="outlined" disabled={!keiyaku00} error={checkbasicItem.incidentUsedCount} />
                              {checkbasicItem.incidentUsedCount ? <FormHelperText>不正な値です</FormHelperText> : (!reqbasicItem.totalPrice && !checkbasicItem.totalPrice && !checkbasicItem.incidentDeposit && !checkbasicItem.incidentCount && !checkbasicItem.incidentAddCount && !checkbasicItem.visitCount) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText>}
                            </FormControl>
                          </Grid>
                          <Grid item>
                            <Button variant="outlined" color="primary" size='small' disabled={!keiyaku00} onClick={incidentUsedCountReset} style={{ margin: '0 2px', padding: '2px' }}>リセット</Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </React.Fragment>) : (
                    <Grid item>
                      <FormControl className={classes.mWidth} margin="dense" variant="outlined" error={checkbasicItem.visitCount}>
                        <TextField id="visitCount" name="visitCount" label="基本訪問回数" value={form.visitCount}
                          size="small" onChange={handleChangeForm} variant="outlined" error={checkbasicItem.visitCount} />
                        {checkbasicItem.visitCount ? <FormHelperText>不正な値です</FormHelperText> : (!reqbasicItem.totalPrice && !checkbasicItem.visitCount) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText>}
                      </FormControl>
                    </Grid>)
                }
                <Grid item>
                  <FormControl className={classes.mWidth} margin="dense" variant="outlined" required error={reqbasicItem.totalPrice || checkbasicItem.totalPrice}>
                    <InputLabel htmlFor="BasictotalPrice">合計金額</InputLabel>
                    <OutlinedInput id="BasictotalPrice" name="totalPrice" value={form.totalPrice}
                      margin="dense" onChange={handleChangeForm} required error={reqbasicItem.totalPrice || checkbasicItem.totalPrice} inputComponent={NumberFormatInput as any} labelWidth={70} />
                    {reqbasicItem.totalPrice ? <FormHelperText>必須項目です</FormHelperText> : checkbasicItem.totalPrice ? <FormHelperText>不正な値です</FormHelperText> : displayIncident ? (!reqbasicItem.totalPrice && !checkbasicItem.totalPrice && !checkbasicItem.incidentDeposit && !checkbasicItem.incidentCount && !checkbasicItem.incidentAddCount && !checkbasicItem.visitCount) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText> : (!reqbasicItem.totalPrice && !checkbasicItem.visitCount) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText>}
                  </FormControl>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <FormControl className={classes.fullWidth} margin="dense" variant="outlined">
                  <TextField id="keiyakuOption" name="keiyakuOption" label="オプション契約内容" multiline size="small" value={form.keiyakuOption} onChange={handleChangeForm} variant="outlined" />
                  <FormHelperText>複数行入力できます</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl className={classes.fullWidth} margin="dense" variant="outlined">
                  <TextField id="keiyakuNote" name="keiyakuNote" label="備考(契約)" multiline size="small" value={form.keiyakuNote} onChange={handleChangeForm} variant="outlined" />
                  <FormHelperText>複数行入力できます</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl component="fieldset">
                  <FormLabel component="legend" className={classes.legendlabel}>メール通知サービス設定</FormLabel>
                  <FormGroup aria-label="position" row>
                    {mailservice &&
                      <React.Fragment>
                        <FormControlLabel
                          value={3}
                          control={<Checkbox color="primary" size="small" name="mailservice3" checked={mailservice[0]} onChange={handleChangeChecked} />}
                          label="QAの回答が登録されたことを通知" />
                        <FormControlLabel
                          value={5}
                          control={<Checkbox color="primary" size="small" name="mailservice5" checked={mailservice[1]} onChange={handleChangeChecked} />}
                          label="QAのステータスが終了になったことを通知" />
                      </React.Fragment>}
                  </FormGroup>
                </FormControl>
              </Grid>

              <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={1}>
                <Grid item>
                  <FormControl className={classes.mWidth} margin="dense" variant="outlined" error={reqbasicItem.machineSettingZipCd || checkbasicItem.machineSettingZipCd}>
                    <TextField id="machineSettingZipCd" name="machineSettingZipCd" label="機械設置場所 〒" value={form.machineSettingZipCd}
                      size="small" onChange={handleChangeForm} variant="outlined" required error={reqbasicItem.machineSettingZipCd || checkbasicItem.machineSettingZipCd} />
                    {reqbasicItem.machineSettingZipCd ? <FormHelperText>必須項目です</FormHelperText> : checkbasicItem.machineSettingZipCd ? <FormHelperText>不正な値です</FormHelperText> : (!reqbasicItem.machineSettingZipCd && !reqbasicItem.machineSettingAddress) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item>
                  <FormControl className={classes.keiyakuWidth} margin="dense" variant="outlined" error={reqbasicItem.machineSettingAddress}>
                    <TextField id="machineSettingAddress" name="machineSettingAddress" label="機械設置場所 住所" value={form.machineSettingAddress} size="small" onChange={handleChangeForm} variant="outlined" required error={reqbasicItem.machineSettingAddress} />
                    {reqbasicItem.machineSettingAddress ? <FormHelperText>必須項目です</FormHelperText> : (!reqbasicItem.machineSettingZipCd && !checkbasicItem.machineSettingZipCd && !reqbasicItem.machineSettingAddress) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText>}
                  </FormControl>
                </Grid>
              </Grid>
            </React.Fragment>}
        </Grid >
      }
    </React.Fragment>
  )
}

export default BasicEditForm